export default {
    ENABLE_TRANSLATION: function (state, data) {
        state.enableTranslation = data.enable
    },
    SET_TRANSLATION_INFO: function (state, data) {
        const { sourceLang, targetLang } = data
        if (sourceLang) {
            state.translation.sourceLang = sourceLang
        }
        if (targetLang) {
            state.translation.targetLang = targetLang
        }
    },
}
